"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/FeedbackModal/icons.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



// Round 3's stroke icons (24px grid) for the Feedback dialog. They draw in
// `currentColor`, so the colour comes from the token on the parent.






const makeIcon = (paths) => {
  const StrokeIcon = ({ size = 16, className }) => (
    _react2.default.createElement('svg', {
      className: className,
      width: size,
      height: size,
      viewBox: "0 0 24 24"   ,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.75",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      'aria-hidden': "true",
      focusable: "false", __self: this, __source: {fileName: _jsxFileName, lineNumber: 15}}

      ,  paths 
    )
  )
  return StrokeIcon
}

// The mobile tab bar's Feedback icon (assets/icons/sidebar/feedback-grey.svg), a
// message with lines, filled in `currentColor`.
 const MessageIcon = ({ size = 16, className }) => (
  _react2.default.createElement('svg', { className: className, width: size, height: size, viewBox: "5 5 22 22"   , fill: "currentColor", 'aria-hidden': "true", focusable: "false", __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}}
    , _react2.default.createElement('path', { d: "M8.2 7h15.6A3.2 3.2 0 0 1 27 10.2v9.1a3.2 3.2 0 0 1-3.2 3.2h-7.07l-4.86 3.9A1.15 1.15 0 0 1 10 25.5v-3H8.2A3.2 3.2 0 0 1 5 19.3v-9.1A3.2 3.2 0 0 1 8.2 7zm0 1.5a1.7 1.7 0 0 0-1.7 1.7v9.1c0 .94.76 1.7 1.7 1.7h3.3v3.39L16.2 21h7.6a1.7 1.7 0 0 0 1.7-1.7v-9.1a1.7 1.7 0 0 0-1.7-1.7H8.2zM11 13.25h10a.75.75 0 1 1 0 1.5H11a.75.75 0 1 1 0-1.5zm0 3h6a.75.75 0 1 1 0 1.5h-6a.75.75 0 1 1 0-1.5z"                                                                       , __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}} )
  )
); exports.MessageIcon = MessageIcon
const HelpIcon = makeIcon(_react2.default.createElement(_react2.default.Fragment, null
  , _react2.default.createElement('circle', { cx: "12", cy: "12", r: "9", __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}} )
  , _react2.default.createElement('path', { d: "M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.7.3-1 .9-1 1.7M12 17h.01"          , __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}} )
))
const StarIcon = makeIcon(
  _react2.default.createElement('path', { d: "M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9l-5.2 2.7 1-5.8L3.5 9.7l5.9-.9z"          , __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}} ),
)
 const BugIcon = makeIcon(_react2.default.createElement(_react2.default.Fragment, null
  , _react2.default.createElement('rect', { x: "7", y: "7", width: "10", height: "13", rx: "5", __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}} )
  , _react2.default.createElement('path', { d: "M12 11v9M7 13H3M21 13h-4M8 8L5.5 5.5M16 8l2.5-2.5M7 17l-3 2M17 17l3 2"          , __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}} )
)); exports.BugIcon = BugIcon

 const CHIP_ICONS = {
  support: HelpIcon,
  feedback: StarIcon,
  bug: exports.BugIcon,
}; exports.CHIP_ICONS = CHIP_ICONS
